import React from "react";
import {IconUbGoogle} from "@unibuddy/icons";
import {SSOAuthButton, SSOAuthButtonText} from "./SSOAuthButton";
import {SSO_PROVIDER} from "./auth-ui/types";

type Props = {
    onClick: () => void;
    disabled?: boolean;
};

export function GoogleAuthButton({disabled, onClick = () => {}}: Props) {
    return (
        <SSOAuthButton
            disabled={disabled}
            onClick={onClick}
            icon={<IconUbGoogle width={20} height={20} />}
        >
            <SSOAuthButtonText provider={SSO_PROVIDER.GOOGLE} />
        </SSOAuthButton>
    );
}
